import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useZoneSections = () => {
  const [loading, setLoading] = useState(false);
  const [zoneSections, setZoneSections] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getZoneSections = ({ zoneGuid } = {}) => {
    if (!zoneGuid) return;
    setLoading(true);

    axiosClient
      .get('InventoryGeo/Section/List', { params: { Guid: zoneGuid } })
      .then(res => {
        if (res.status === 200) {
          const list = res.data.value?.list || res.data.value || [];
          setZoneSections(
            (Array.isArray(list) ? list : []).map((element, index) => ({
              guid: element.guid,
              order: element.order ?? index + 1,
              display: element.display,
            })),
          );
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getZoneSections, loading, zoneSections };
};

export default useZoneSections;
